import React from "react";
import { formatLocalDate } from "src/utils/common";
import VoucherNumberCell from "./VoucherNumberCell";
import { Chip, Tooltip } from "@mui/material";
import { handleViewAllVoucher } from "src/store/reservations/actions/ReservationClientVoucherActions";

const MRTVoucherColumnDefinitions = (dispatch, navigate) => [
    {
        accessorKey: "VoucherNumber",
        header: "Voucher Number",
        size: "auto",
        Cell: ({ row }) => (
            <VoucherNumberCell
                voucherId={row.original.Id}
                voucherNo={row.original.VoucherNumber}
            />
        ),
    },
    {
        accessorKey: "CreatedUser.DisplayName",
        header: "Created User",
        size: "auto",
        Cell: ({ row }) => row.original.CreatedUser?.DisplayName || "N/A",
    },
    {
        accessorKey: "Active",
        header: "Status",
        size: "auto",
        Cell: ({ row }) => row.original.Active
            ?
            <Chip
                color="secondary"
                sx={{ borderRadius: '6px' }}
                size="small"
                label="Latest"
            />
            :
            <Chip
                color="default"
                sx={{ borderRadius: '6px' }}
                size="small"
                label="Outdated"
            />,
    },
    {
        accessorKey: "CreatedDate",
        header: "Generated Date",
        size: "auto",
        Cell: ({ row }) => formatLocalDate(row.original.CreatedDate),
    },
    {
        id: 'actions',
        header: 'Actions',
        size: "auto",
        Cell: ({ row }) => (
            <Tooltip title="View All Vouchers">
                <Chip
                    color="primary"
                    sx={{ borderRadius: '6px' }}
                    size="small"
                    label="View"
                    onClick={() => handleViewAllVoucher(row.original.ReservationId, row.original.Id, dispatch, navigate)}
                />
            </Tooltip>
        ),
    },
];

export default MRTVoucherColumnDefinitions;
